export default {
  lineAt: '@connextcc', // Default value
  linkLine: 'https://lin.ee/xalM4XE', // Default value
  defaultAdminContactLineLink: 'https://lin.ee/xalM4XE',
  adminContactLineLink: 'https://lin.ee/xalM4XE',
  domains: [],
  partnerReferralHost: 'connextcc.com',
  isLoaded: false
}
